export class SoFAModal {

  SoFAc_ID: number
  HeadersID: number
  HeadersName: string
  FinancialPeriodsID: number
  CharityID: number
  Activity_Name: string
  Sofa_NotesID: string
  Unrestricted_Funds: number
  Restricted_Income_Funds: number
  Endowment_Funds: number
  Total_Funds: number
  Prior_Year_Funds: number
  CreatedDate: Date
  Createdby: number
  Modifiedby: number
  ModifiedDate: Date
  UserId: number
  CentralUserId: any
  IsActive: boolean

  constructor(init?: Partial<SoFAModal>) {
   // Object.(this, init);
  }
}
